const comments = [
  {
    name: '吃瓜小能手',
    avatar: 'C',
    avatarColor: 'bg-primary-500',
    time: '2天前',
    content: '这个黑料导航站太方便了，51黑料、91黑料、17黑料一个页面全搞定，再也不用到处找入口了，推荐给朋友们都在用。',
    likes: 128,
  },
  {
    name: '数字游民',
    avatar: '数',
    avatarColor: 'bg-accent-500',
    time: '3天前',
    content: '718黑料合集整理得很完整，按时间线归档查找很方便，希望继续保持更新频率。安全加密访问这点也让人放心。',
    likes: 96,
  },
  {
    name: '深夜追更人',
    avatar: '夜',
    avatarColor: 'bg-secondary-500',
    time: '4天前',
    content: '每天必刷这个页面，51黑料最新动态和91黑料吃瓜内容更新很及时，作为黑料爱好者表示非常满意！',
    likes: 87,
  },
  {
    name: '资讯猎手',
    avatar: '猎',
    avatarColor: 'bg-primary-500',
    time: '5天前',
    content: '之前每次找17黑料地址都要搜半天，现在直接从这个页面进去就行。话题榜单也很有参考价值，能快速了解当前热点。',
    likes: 64,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">用户评价</h2>
          <p className="mt-2 text-sm text-foreground-600">来自黑料平台用户的真实反馈</p>
        </div>
        <div className="space-y-4">
          {comments.map((comment, idx) => (
            <div key={idx} className="p-5 rounded-xl bg-background-50 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${comment.avatarColor} text-background-50 text-sm font-bold flex-shrink-0`}>
                  {comment.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{comment.name}</span>
                    <span className="text-xs text-foreground-500">{comment.time}</span>
                  </div>
                </div>
                <div className="flex items-center gap-1 text-foreground-400 flex-shrink-0">
                  <i className="ri-thumb-up-line text-sm"></i>
                  <span className="text-xs">{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}